import { RequestState } from '../../../modules/types'
import { Partner } from '../../partner/store/store'

export type User = {
  id: string
  firstName: string
  lastName: string
  avatarUrl: string
  avatarColour: string
  email: string
  intercomUserHash: string
  dateFormat: string
  timeFormat: string
  timezone: string
  countryCode: string
}

export type AuthState = {
  requestState: RequestState
  error?: string
  user?: User
  partners: Partner[]
  currentPartner?: Partner
  isPapertrailEmployee?: boolean
}

export const initialAuthState = {
  requestState: RequestState.NotLoaded,
  partners: []
}
